<template>
  <form action="#" class="f-form">
    <div class="l-grid-wrapper">
      <div class="l-grid u-space-v-4 u-space-h-4">
        <div class="l-grid__item l-grid__item-4 u-hidden@m">
          <figure class="o-image-wrapper">
            <img :src="urlImage" />
          </figure>
        </div>
        <div class="l-grid__item l-grid__item-8 l-grid__item-12@m">
          <!-- <loading-indicator :isLoading="isProcessing" loadingText="Trwa zapisywanie..."></loading-indicator> -->

          <h3 class="t-head t-head--default u-paint-green-1">
            <strong>
            <template v-if="isSended">Gotowe!</template>
            <template v-else>Jeszcze tylko jeden krok...</template>
            </strong>
          </h3>

          <template v-if="isSended">
            <div class="c-message c-message--default c-message--theme-2 u-text-center">
              <span class="c-message__ico o-ico o-ico--hand-ok o-ico--l u-paint-green-1">
                <svg aria-hidden="true"><use xlink:href="#ico-hand-ok"></use></svg>
              </span>
              <div class="t-content">
                <p>
                  <strong>Damy Ci znać, gdy produkt znów będzie dostępny.</strong>
                </p>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="f-message is-error" v-html="errors.global" v-if="errors.global">{{ errors.global }}</p>

            <div class="f-field">
              <input v-model="email" type="email" value="" placeholder="Adres e-mail" class="f-control f-control--text f-control--default f-control--theme-2 f-control--sh-3" v-bind:class="{ 'is-error': errors.email }" />
              <p class="f-message is-error" v-if="errors.email">{{ errors.email }}</p>
              <p class="f-message is-error" v-if="isExists">Masz już powiadomienie dla tego produktu</p>
              <p class="f-message is-error" v-if="isInvalid">Twój adres jest niepoprawny.</p>
            </div>

            <div class="f-field">
              <label for="label-1" class="f-control f-control--choose f-control--choose--alt" v-bind:class="{ 'is-error': errors.accept }">
                <input v-model="accept" type="checkbox" name="accept" id="label-1" />
                <span class="f-control__indicator"></span>
                <span class="f-control__label"><span class="u-paint-red-1">*</span> Akceptuję <a class="notification_link" href="/content/3-regulamin-sklepu" target="_blank">Regulamin</a> oraz <a class="notification_link" href="/content/2-polityka-prywatnosci" target="_blank">Politykę prywatności</a>.</span>
              </label>
            </div>

            <ul class="c-actions-list">
              <li class="c-actions-list__item u-grow">
                <button type="submit" class="c-btn c-btn--primary c-btn--full c-btn--theme-1 c-btn--theme-1--important c-btn--full-important c-btn--border-radius-full" @click.prevent="sendForm">
                  Powiadom mnie
                </button>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { addNotification } from '@/api/productNotifications'
import LoadingIndicator from '@/components/LoadingIndicator'
// import { GetProductListConfig, GetProductListNotificationConfig } from '@/config'

export default {
  props: {
    isForm: Boolean,
    urlImage: String,
    idProduct: this.idProduct,
    urlProduct: this.urlProduct
  },

  components: {
    LoadingIndicator
  },

  data () {
    return {
      email: '',
      accept: '',
      errors: [],
      isProcessing: false,
      isSended: null,
      isInvalid: null,
      isExists: null,
      combinationId: null,
      image: null,
      productConfig: {},
      notificationConfig: {}
    }
  },

  mounted () {
    if (!this.isForm) {
      this.isSended = true
      this.processNotification()
    }
  },

  methods: {
    sendForm () {
      if (this.validate()) {
        this.isSended = false
        this.isInvalid = false
        this.isExists = false

        this.processNotification()
      }
    },

    processNotification () {
      const self = this
      self.setIsProcessing(true)

      addNotification({
        url: this.urlProduct,
        email: this.email,
        productId: this.idProduct,
        combinationId: 0
      })
        .then(result => {
          self.setIsProcessing(false)
          this.isSended = true
          this.isExists = true
          this.isInvalid = true
        })
        .catch(() => {
          self.setIsProcessing(false)
          self.setGlobalError('Nie udało się zapisać. Spróbuj ponownie.')
        })
    },

    validate () {
      this.errors = {}

      this.validateBody()

      return Object.keys(this.errors).length === 0
    },

    validateBody () {
      if (!this.email) {
        this.errors['email'] = 'E-mail jest wymagany'
      }

      if (!this.accept) {
        this.errors['accept'] = 'Proszę zaakceptować regulamin'
      }
    },

    setGlobalError (error) {
      this.errors = {global: error}
    },

    setIsProcessing (isProcessing) {
      this.isProcessing = isProcessing
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductListNotification/ProductListNotificationModalSave.vue